(function() {
  function activatePanel(root, targetId) {
    root.querySelectorAll('[data-thurso-sidebar-trigger]').forEach(function(trigger) {
      var isActive = trigger.getAttribute('data-target') === targetId;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-expanded', isActive ? 'true' : 'false');
    });

    root.querySelectorAll('.thurso-outlet-mega__sidebar-panel').forEach(function(panel) {
      var isActive = panel.id === targetId;
      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });
  }

  function init(root) {
    root.querySelectorAll('.thurso-outlet-mega--sidebar').forEach(function(sidebarMenu) {
      if (sidebarMenu.dataset.thursoSidebarReady === 'true') {
        return;
      }

      var triggers = sidebarMenu.querySelectorAll('[data-thurso-sidebar-trigger]');
      if (!triggers.length) {
        return;
      }

      sidebarMenu.dataset.thursoSidebarReady = 'true';

      triggers.forEach(function(trigger) {
        var activate = function() {
          activatePanel(sidebarMenu, trigger.getAttribute('data-target'));
        };
        trigger.addEventListener('mouseenter', activate);
        trigger.addEventListener('focus', activate);
        trigger.addEventListener('click', activate);
      });
    });

    root.querySelectorAll('[data-thurso-mobile-sidebar-menu] .collapsible-trigger').forEach(function(trigger) {
      if (trigger.dataset.thursoMobileHeightReady === 'true') {
        return;
      }

      trigger.dataset.thursoMobileHeightReady = 'true';

      trigger.addEventListener('click', function() {
        var topPanel = trigger.closest('.mobile-nav__sublist.collapsible-content--all');
        if (!topPanel || !topPanel.classList.contains('is-open')) {
          return;
        }

        topPanel.style.height = topPanel.offsetHeight + 'px';
      }, true);

      trigger.addEventListener('click', function() {
        var topPanel = trigger.closest('.mobile-nav__sublist.collapsible-content--all');
        if (!topPanel) {
          return;
        }

        window.setTimeout(function() {
          if (topPanel.classList.contains('is-open')) {
            topPanel.style.height = 'auto';
          }
        }, 560);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function(event) {
    init(event.target);
  });
})();
